import { useEffect, type ReactNode } from 'react'

import { applyResolvedTheme, useThemeStore } from '@/stores'

export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useThemeStore((s) => s.theme)
  const resolveTheme = useThemeStore((s) => s.resolveTheme)

  useEffect(() => {
    applyResolvedTheme(resolveTheme())

    if (theme !== 'system') return

    const media = window.matchMedia('(prefers-color-scheme: dark)')
    const onChange = () => applyResolvedTheme(resolveTheme())
    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }, [theme, resolveTheme])

  return children
}
